import { ProductBadgeStrategyFunding } from './product-badge-strategy.funding';
import { IProductBadgeStrategy, ProductBadgeVariant } from './product-badge-strategy.interface';
import { ProductBadgeStrategyMpsV1 } from '@services/MarppleShop/renderApp/components/cells/ProductBadgeList/strategies/product-badge-strategy.v1.ts';

export class ProductBadgeStrategyFactory {
  private static readonly STRATEGY_MAP = new Map<ProductBadgeVariant, IProductBadgeStrategy<any>>([
    [ProductBadgeVariant.DEFAULT_BADGE, new ProductBadgeStrategyMpsV1()],
    [ProductBadgeVariant.FUNDING_BADGE, new ProductBadgeStrategyFunding()],
  ]);

  static create<T extends IProductBadgeStrategy<any>>(variant: ProductBadgeVariant): T {
    const strategy = this.STRATEGY_MAP.get(variant);

    if (!strategy) {
      throw new Error('Unable to create strategy');
    }
    return strategy as T;
  }
}
